import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IOSSwitch from "@components/common/Switch";

interface NDisplaySectionProps {
  showSliceN: boolean;
  showChartN: boolean;
  onShowSliceNChange: (value: boolean) => void;
  onShowChartNChange: (value: boolean) => void;
}

const NDisplaySection: React.FC<NDisplaySectionProps> = ({
  showSliceN,
  showChartN,
  onShowSliceNChange,
  onShowChartNChange,
}) => {
  return (
    <Accordion
      defaultExpanded
      sx={{ boxShadow: "none", border: "1px solid #eee" }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          N Display
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography>Show Slice N</Typography>
              <IOSSwitch
                checked={showSliceN}
                onChange={(e) => onShowSliceNChange(e.target.checked)}
                size="small"
              />
            </Box>
            <Typography variant="caption" color="text.secondary">
              Also enables Legend and keeps it on until Show Slice N is turned
              off.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography>Show Chart N</Typography>
            <IOSSwitch
              checked={showChartN}
              onChange={(e) => onShowChartNChange(e.target.checked)}
              size="small"
            />
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default NDisplaySection;
